import { Box, Button, ButtonBase, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Tour from '../../../models/Tour';
import IncludedBasic from './common/IncludedBasic';

interface TourListItemSimpleProps {
    tour: Tour | undefined;
    showDetails?: boolean;
    children: React.ReactNode | React.ReactNode[]
}

const TourListItemSimple: React.FC<TourListItemSimpleProps> = ({ tour, children, showDetails = false }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (tour === undefined) {
        return null;
    }


    return (
        <ButtonBase
            onClick={() => navigate(`/tours?tourId=${tour.id}`)}
            sx={{
                width: "100%",
                height: "100%",
                borderRadius: 3,
                textAlign: "left",
                transition: "transform 220ms ease",
                ":hover": {
                    transform: "translateY(-8px)"
                }
                // maxWidth: { md: 420 },
                // flex: "1 1 300px"
            }}>
            <Paper
                sx={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    position: "relative",
                    borderRadius: 3,
                    border: "1px solid transparent",
                    background: "linear-gradient(180deg, rgba(45, 49, 54, 0.96), rgba(26, 29, 32, 0.98))",
                    boxShadow: "0 22px 42px rgba(0, 0, 0, 0.34)",
                    transition: "border-color 220ms ease, box-shadow 220ms ease",
                    "&:hover": {
                        borderColor: "rgba(223, 92, 45, 0.55)",
                        boxShadow: "0 30px 60px rgba(0, 0, 0, 0.44)"
                    },
                }}>
                <Grid
                    px={2.5}
                    py={2.5}
                    container
                    direction={"column"}
                    alignItems={"center"}
                    sx={{
                        background: "linear-gradient(135deg, rgba(223, 92, 45, 0.98), rgba(197, 70, 31, 0.92))",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
                    }}>
                    <Typography
                        fontWeight={800}
                        color={"#fff"}
                        textAlign={"center"}
                        sx={{
                            letterSpacing: 0.2,
                            textShadow: "0 2px 14px rgba(0, 0, 0, 0.28)"
                        }}>
                        {`${tour.nightCount} ${t("tour.nights")} / ${tour.rideDayCount} ${t("tour.daysRide")}`}
                    </Typography>

                    {showDetails && (
                        <>
                            <Box display={"flex"} flexDirection={"row"} mt={1.5} alignItems={"center"}>
                                <Typography variant='h4' color={"#fff"} fontWeight={600}>
                                    €
                                </Typography>
                                <Typography variant='h2' ml={0.5} color={"#fff"} fontWeight={600}>
                                    {`${tour.priceWithOwnMotorcycle}`}
                                </Typography>
                            </Box>

                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography color={"#fff"} fontWeight={600}>
                                    €
                                </Typography>
                                <Typography variant='h4' ml={0.5} color={"#fff"} fontWeight={600}>
                                    {`${tour.price}`}
                                </Typography>
                                <Typography ml={0.5} color={"#fff"}>
                                    {`${t("tour.withOurMotorcycle")}`}
                                </Typography>
                            </Box>
                        </>
                    )}

                </Grid>
                <Grid
                    px={{ xs: 3, md: 3.5 }}
                    py={{ xs: 3, md: 3.5 }}
                    minHeight={150}
                    container
                    direction={"column"}
                    alignItems={"flex-start"}
                    justifyContent={"space-between"}>
                    <Box>
                        <IncludedBasic tour={tour} />
                        {showDetails && children}
                    </Box>
                    {!showDetails && (
                        <Button
                            sx={{
                                width: "100%",
                                mt: 3,
                                py: 1.1,
                                color: "primary.light",
                                border: "1px solid rgba(223, 92, 45, 0.26)",
                                backgroundColor: "rgba(223, 92, 45, 0.08)",
                                fontWeight: 700,
                                "&:hover": {
                                    borderColor: "primary.main",
                                    backgroundColor: "rgba(223, 92, 45, 0.16)"
                                }
                            }}>
                            {t("tour.details")}
                        </Button>
                    )}
                </Grid>
            </Paper >
        </ButtonBase>
    )
}

export default TourListItemSimple;